import { arrInc } from '../../../fun-js-lib/arr'
import { canvasFillStyled, canvasFonted, canvasTextCentered } from '../../../fun-js-lib/canvas'
import Rect from '../../../fun-js-lib/geometry/Rect'
import { drawZLine } from '../../canvasDraw'
import { drawTextLines } from '../draw-styled-text/draw-text-lines'
import { getLinesFonted } from '../draw-styled-text/line'
import { baseLineInterval } from '../otherPageImg'
import { nLinesInRemarks } from '../texts'
import { maxNLinesOnMainPageWorkDescription, normalWorkDescriptionFont, workDescriptionLinesRange, workDescriptionRect } from './workDescription'

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 * @param {import('../../constructionLog').LogPage} page 
 */
export function drawRemarks (context, linesColor, page) {
  drawLabel(context, linesColor)
  drawContent(context, page)
  drawZIfNeed(context, page)
}

export function remarksRect () {
  let rect = workDescriptionRect()
  return Rect.plain({
    x: rect.x + 1790,
    y: rect.y,
    w: 790,
    h: rect.h
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
function drawLabel (context, linesColor) {
  const text = 'ПРИМЕДБЕ'
  const rect = labelBlockRect()
  canvasFillStyled(context, linesColor, () => {
    canvasTextCentered(context, text, rect, 30)
  })
}

function labelBlockRect () {
  let rect = remarksRect()
  return Rect.plain({
    x: rect.x,
    y: rect.y,
    w: rect.w,
    h: 70
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('../../constructionLog').LogPage} page 
 */
function drawContent (context, page) {
  let rect = contentRect()
  const lines = getLines(context, page)
  const lineInterval = baseLineInterval()
  canvasFonted(context, normalWorkDescriptionFont, () => {
    drawTextLines(context, lines, linesRange(), rect, lineInterval)
  })
}

const linesRange = () => 
  workDescriptionLinesRange()

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('../../constructionLog').LogPage} page 
 */
function getLines (context, page) {
  const json = page.remarks
  const linesWidths = remarksLinesWidths()
  const font = normalWorkDescriptionFont
  const lines = getLinesFonted(context, json, linesWidths, font)
  return lines
}

export const remarksLinesWidths = () =>
  arrInc(maxNLinesOnMainPageWorkDescription).map(() => contentRect().w)

function contentBlockRect () {
  let rect = remarksRect()
  return Rect.plain({
    x: rect.x,
    y: rect.y + labelBlockRect().h,
    w: rect.w,
    h: rect.h - labelBlockRect().h
  })
}

function contentRect () {
  let rect = contentBlockRect()
  return Rect.plain({
    x: rect.x + 20,
    y: rect.y,
    w: rect.w - 40,
    h: rect.h
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('../../constructionLog').LogPage} page 
 */
function drawZIfNeed (context, page) {
  const nLines = nLinesInRemarks(context, page.remarks)
  if (nLines < maxNLinesOnMainPageWorkDescription) {
    let rect = contentRect()
    let textHeight = nLines * baseLineInterval()
    let yTopIndent = 10
    let zRect = Rect.plain({
      x: rect.x,
      y: rect.y + textHeight + yTopIndent,
      w: rect.w,
      h: rect.h - yTopIndent - textHeight - 4
    })
    drawZLine(context, zRect)
  }
}

export const maxNLinesInRemarks = 18